export default __webpack_public_path__ + "static/media/Alchemy.ec491ba0.svg";